import CircularProgress from '@mui/material/CircularProgress';
import { Button } from '@openx/components-core/lib/Button/Button';
import type { DealPromptContextType } from '../../utils/types';

type RegenerateButtonProps = {
  loading: boolean;
  disabled: boolean;
  buttonLabel: string;
  onClick: () => void;
  contextType: DealPromptContextType;
};

export const RegenerateButton = ({ loading, disabled, buttonLabel, onClick, contextType }: RegenerateButtonProps) => {
  return (
    <Button
      data-test="deal-prompt-search"
      data-pendo-feature={`deal-prompt-main-${contextType}-regenerate-filters`}
      onClick={onClick}
      disabled={disabled || loading}
      variant="contained"
      color="primary"
      sx={{
        minWidth: 'fit-content',
        alignSelf: 'flex-end',
      }}
    >
      {loading ? <CircularProgress size={18} sx={{ color: 'inherit' }} /> : buttonLabel}
    </Button>
  );
};
